import { Routes } from '.generated/templates/Project.Routes.model';
import classnames from 'tailwindcss-classnames';
import Button from 'components/helpers/Button';
import ImageWrapper from 'components/helpers/ImageWrapper/ImageWrapper';

export type EmptyCartPageProps = Routes.Fields.CartPage;
const EmptyCart = ({ fields }: EmptyCartPageProps): JSX.Element => {
  const nextImageField = {
    ...fields?.emptyCartIcon,
  };
  return (
    <>
      <div className={classnames('flex', 'flex-wrap', 'justify-center')}>
        <ImageWrapper field={nextImageField} />
        <div
          className={classnames(
            'mt-[23px]',
            'w-full',
            'text-center',
            'text-3xl',
            'font-medium',
            'leading-10',
            'md:text-5xl',
            'md:leading-11.9'
          )}
        >
          {fields?.emptyCartLabel.value}
        </div>

        <Button
          variant="primary"
          linkField={fields?.ExploreCatalogLink}
          className={classnames('mb-[50px]', 'mt-[23px]')}
        />
      </div>
    </>
  );
};
export default EmptyCart;
